// extracted by mini-css-extract-plugin
module.exports = {"modal":"ContactsModal_modal__1lbxr","body":"ContactsModal_body__29D3t","item":"ContactsModal_item__2QrIH","link":"ContactsModal_link__2bcXJ"};